import { render, staticRenderFns } from "./BudgetWizard.vue?vue&type=template&id=4f08c3f0&scoped=true"
import script from "./BudgetWizard.vue?vue&type=script&lang=js"
export * from "./BudgetWizard.vue?vue&type=script&lang=js"
import style0 from "./BudgetWizard.vue?vue&type=style&index=0&id=4f08c3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08c3f0",
  null
  
)

export default component.exports